export default {
	FEATURE: {
		userAvatar: true,
		userCover: true,
		userSettingsChangePwd: false
	},
	CONFIG: {}
}